import {
  beContentDeleteDynamicContent,
  beContentGetDynamicContentLastSendDate,
  getDynamicContentList
} from 'Api/beEmailMessageApi'
import { beFiltersGetFilter } from 'Api/beFiltersApi'
import { getIntegrationsByTag } from 'Api/beIntegrationCatalog'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  fromUTCtoZoneFormatted,
  storeGet
} from 'mailup-react-helpers'

export async function getIntegrationsAction(lang, category) {
  const resp = await getIntegrationsByTag(lang, category)
  return resp
}
export async function getFilterAction(lang, category) {
  const resp = await beFiltersGetFilter(lang, category)
  return resp
}
export async function deleteDynamicContentAction(idContent) {
  const result = await beContentDeleteDynamicContent(idContent)
  return result
}
export async function getDynamicContentLastSentAction(idContent) {
  const ids = [idContent]
  const result = await beContentGetDynamicContentLastSendDate(ids)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const tmp = result.find(({ Id }) => Id === idContent)
  if (tmp.LastSendDate) {
    const date = new Date(tmp.LastSendDate)
    tmp.LastSendDate = fromUTCtoZoneFormatted(
      date,
      TimeZoneCode,
      'YYYY-MM-DD HH:mm'
    )
  } else {
    tmp.LastSendDate = '-'
  }
  return tmp.LastSendDate
}
export async function getDynamicContentListAction({
  pageSize,
  pageNumber,
  orderBy,
  orderDescending
}) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const { Items, TotalItems, PageNumber, PageSize } =
    await getDynamicContentList(idList, {
      pageSize,
      pageNumber,
      orderBy,
      orderDescending
    })

  const pageNotExist = !Items.length && TotalItems && PageNumber > 1

  if (Items.length) {
    Items.forEach((i) => {
      if (i.CreationDate) {
        const date = new Date(i.CreationDate)
        i.CreationDate = fromUTCtoZoneFormatted(
          date,
          TimeZoneCode,
          'YYYY-MM-DD HH:mm'
        )
      } else {
        i.CreationDate = '-'
      }
    })
  }
  if (pageNotExist) {
    const retryPageNumber = Math.ceil(TotalItems / pageSize)
    const { Items: retryItems } = await getDynamicContentList(
      idList,
      pageSize,
      pageNumber,
      orderBy,
      orderDescending
    )

    return {
      items: retryItems,
      totalItems: TotalItems,
      pageNumber: retryPageNumber,
      pageSize: PageSize
    }
  }

  return {
    items: Items,
    totalItems: TotalItems,
    pageNumber: PageNumber,
    pageSize: PageSize
  }
}
